var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 27,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(-0.00390625) scale(0.0234375 0.0277778)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 43,
    height: 36,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAkCAYAAAAQC8MVAAAEbklEQVRYCe1YWU8bVxT+5s7mGZtx8IJZE6eFUKBRBFVVpG6K8pDHPPYlv6F/oL+nfWmlPrTiJcpLq1aNUAsqpSWIrTSYzdjGePDsU52LTYzUoAFhYaRassa+d+bc7yzfd44thGEY4oa82A3ByWH+D7Zd2ZKahl3PR63mwPOD5tK1XRkTENdkqKoMQXgNg4M1TQu/zBWwuLQP379+vhHAnrSOR5/kkU0nwNhJtQqu64bfzizhm5nl1y50yKc7gwa++PxDJA2NI2Ku6+O756sdAu8sjL9fVbG0egC/UZocrG37Z+/qoG9bhSqanYBdf4WeH5mghe+cYJLYuXLb4Bb3SCKZmHw3e75717ib69FPTxfqdSv0fO90odM+kGypigpRZDhtClcJkggR8GITIIotqg6A5ibaJy0VWhU/AoBIYG3Hx+ZWFY4b4J23U6DSKVXqfC2T0rhoF0t1DPV3IaZKeLV9hN19E0Te3qyOoT4DmiaBVGd5vYxK1cJIvhvZjA6RnXXmPMyRwJrHLn58sQUClB8ywAQBvy3s4qfZAj7+YADVIwd/Lh/gyeNh3q6f/bCBmulCUUTuXHcyxsGubVbw/bNVrG0e4rMno/jIGIAYiwSB+xDpTkqlrknwgwCO45+CG+hNgN7rmwUkDRW6JuPX33dRqtj4dHoQtwcMxHUZRkJF3fIw98ceVEVEV1yBaboXnkOigWWMgw2CkAOlCFWqNt6f7OWFXyrX0ZdLoDtJRDhJK9XlYH8XjITCo7L4sgjqSA8msrAcH5Qtz2sR0fPy39iLJLAnkZX5kFPYrYEO7uuJY3wkjaOag5rpcKDJpIrR4RTSt2J4MbeN2fltvn9cdzG/uM9JRZnQYhJozbvg0BQRLEVWhmV7WFkv8zTfH8sgEVdweGQjFASkuzVey8P5W3j88C50Xcbs/A7IuZWNClY2iFg2fp4tYGfP5DXdlshKIs2XEi8BOjiX0TF+L4N63cNB2eJ7SUNB8eAYh1Ub/bk4v+eY9ksWFv4q8kTmBw1eTkQ8quGLzs6RapakSlUlXmN+EOLBeBbJLhXbuzUUD+qcQESihaUif8syw/aeCRrxqkc21jcrmBjNYHqqj0vbzPM1rP9zeOGajQSWwkJ6+vhhnoMcH03zSJEDYyMpLkvplAaKZKliwXZ93L2d5LJVrTl4T+jFxL0MVw5qBFP3c+jJxtGVUBvUiXaJ3G7pFwSRokk2Mk9ptCyfrxFpqAab6aXmQDJFDYXm0VhMQnNgoubgeD70mHyqHm+C29puI4N9k7F2r7eClcLAg/3yy3afeWn7Ss8U0DfJn5cQeHCWv760sXY/yCSlBSxChPZhu8+8vH3PAp+IAERqCpc/6WqfZIIoA0LnYmbxHNCYIpkoyZDvPLraEFyRNaaloPROQxRFblEIwjC0zTKOl76CuzOL0CrTPH9Fx13SjKxDNN6CPvYUanoEkiSfgG3+P+u5buOnyDUDbfjHmAgmMtC1+RKaYJsLnXztXGb9R9RuFNh/AWXv2WamoBNDAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.1c2384b1dbcbeba0d951aef35eae9fa8.svg";
export { ForwardRef as ReactComponent };